/*
 * @Description: 地图
 * @Author: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @Date: 2022-07-14 09:50:19
 * @LastEditTime: 2023-08-04 16:03:08
 * @LastEditors: DXV-RGWU-TUFH-RFCY-IEGMYY
 */
import {
  get
} from '../index'
export default {
  // 技-师地图
  getMapCoach (querys) {
    return get('massage/admin/Admin/getMapCoach', querys)
  },
  // 城市下拉
  citySelect (querys) {
    return get('massage/admin/Admin/citySelect', querys)
  },
  // 技-师详情
  coachInfo (querys) {
    return get('massage/admin/Admin/coachInfo', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/map.js